import React from 'react';
import cn from 'classnames';
import BaseAwards from '@/Framework/UI/Pages/Landing/Sections/Awards';

import styles from './awards.scss';

interface IProps {
  className?: string,
  pattern?: React.ReactElement,
}

const Awards = (props: IProps) => (
  <div className={ cn(styles.awardsWrp, props.className) }>
    { props.pattern }
    <BaseAwards
      className={ styles.awards }
    />
  </div>
);

export default Awards;
